<template>
  <div>
    <div v-if="(!data || data.length === 0) && loading">
      <SingleChartLoader></SingleChartLoader>
    </div>
    <div v-if="(!data || data.length === 0) && !loading" class="text-center py-5">
      <h4>Chart data is not available.</h4>
    </div>
    <div v-else-if="data && data.length > 0 && yDataAvailable === true && !loading"
      class="chart-column liberated-gas-chart-column">
      <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
      <div class="chart-name-top">
      <h6>{{chartTitle}}</h6>
      </div>
      <div v-if="isMounted" class="main-chart mr-md-2">
        <div :ref="chartId"></div>
      </div>
      <v-dialog v-model="modal" class="multi-chart-preview-div dashboard-chart-preview composition">
        <v-card class="position-relative studio-card">
          <v-card-text>
            <div class="popup-top">
              <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isModalYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleModalYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
              <div class="chart-name-top w-100">
                <h6>{{chartTitle}}</h6>
              </div>
              <!-- <img :src="cross" alt="cross" @click="closeModal" class="chart-preview-close-btn"> -->
            </div>
            <div :ref="modalChartId" class="modal-chart-container"></div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else-if="data && data.length > 0 && yDataAvailable === false" class="text-center pt-5 pb-12">
      <h4>Chart data is not available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import SingleChartLoader from "../../Loaders/SingleChartLoader.vue";
import downloadIcon from '../../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../../assets/Svg/camIcon.svg';
import Expand from "../../../../assets/Svg/Chart/expand-btn.svg";
import { mapGetters } from "vuex";

export default {
  name: "GasCompComponentChart",
  components: {
    SingleChartLoader,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    toggleFraction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tenantId: localStorage.getItem("tenantId"),
      cross: require("../../../../assets/Svg/Chart/chart-cross.svg"),
      chartId: "lineChart",
      chartData: [],
      uniqueFluidComponents: [],
      modal: false,
      modalChartId: "modalLineChart",
      chartTitle: "Vapor Compositions Across Components at Various Pressures",
      isMounted: false,
      yDataAvailable: true,
      yAxisScale: "linear",
    isYLog: false,
    modalYAxisScale: "linear",
    isModalYLog: false,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  watch: {
    data(newVal, oldVal) {
      if (newVal !== oldVal && newVal.length > 0) {
        this.plotChart();
      }
    },
    yAxisScale() {
      this.plotChart();
    },
    // Watch for dark mode changes to reload plots and update colors
    isDarkMode() {
      this.plotChart();
    }
  },
  methods: {
    handleYScaleToggleChange() {
    // Initialize default linear scale for the variable if not exists
    if (this.yAxisScale === undefined) {
      this.yAxisScale = 'linear';
    }

      this.yAxisScale = this.isYLog ? "log" : "linear";
      this.modalYAxisScale = this.yAxisScale;
    if(this.modalYAxisScale === "log") {
      this.isModalYLog = true;
    }
    else {
this.isModalYLog = false;
    }
  },
  handleModalYScaleToggleChange() {
    // Initialize default linear scale for the variable if not exists
    if (this.modalYAxisScale === undefined) {
      this.modalYAxisScale = 'linear';
    }

      this.modalYAxisScale = this.isModalYLog ? "log" : "linear";

      this.plotModalChart()
  },
    plotChart() {
      const differentiaLiberationData = this.data;
      const vaporMoleFractionsByComponent = {};
      const vaporMassFractionsByComponent = {};

      differentiaLiberationData.forEach((step) => {
        const fluidComponent = step.fluidComponentReference;
        const vaporMoleFraction = step.vapor_MoleFraction;
        const vaporMassFraction = step.vapor_MassFraction;
        const stepPressure = step.stepPressure;

        if (!vaporMoleFractionsByComponent[stepPressure]) {
          vaporMoleFractionsByComponent[stepPressure] = [];
        }

        vaporMoleFractionsByComponent[stepPressure].push({ component: fluidComponent, moleFraction: vaporMoleFraction });

        if (!vaporMassFractionsByComponent[stepPressure]) {
          vaporMassFractionsByComponent[stepPressure] = [];
        }

        vaporMassFractionsByComponent[stepPressure].push({ component: fluidComponent, massFraction: vaporMassFraction });
      });

      if (this.toggleFraction === true) {
        this.chartData = Object.entries(vaporMoleFractionsByComponent).map(([component, values]) => {
          const xData = values.map(entry => entry.component);
          const yData = values.map(entry => entry.moleFraction);

          if (yData.every(value => value === undefined) || yData.every(value => value === null) || !yData) {
            this.yDataAvailable = false;
          }
          else {
            this.yDataAvailable = true;
          }

          return {
            name: component,
            x: xData,
            y: yData,
          };
        });
      } else if (this.toggleFraction === false) {
        this.chartData = Object.entries(vaporMassFractionsByComponent).map(([component, values]) => {
          const xData = values.map(entry => entry.component);
          const yData = values.map(entry => entry.massFraction);

          if (yData.every(value => value === undefined) || yData.every(value => value === null) || !yData) {
            this.yDataAvailable = false;
          }
          else {
            this.yDataAvailable = true;
          }

          return {
            name: component,
            x: xData,
            y: yData,
          };
        });
      }

      this.$nextTick(() => {
        if (this.isMounted && this.$refs[this.chartId]) {
          this.plotChartWithData();
        }
      });
    },

    plotChartWithData() {
      this.$nextTick(() => {
        const traces = this.chartData.map((series) => ({
          x: series.x,
          y: series.y,
          type: "scatter",
          mode: "lines+markers",
          name: series.name,
          hovertemplate: `%{y:.3f}<extra></extra>`
        }));

        const yAxisTitle = this.toggleFraction ? "Mole%" : "Mass%";

        const layout = {
          // title: {
          //   text: this.chartTitle,
          //   font: { size: 11 },
          //   x: 0.1,
          // },
          xaxis: {
            title: {
              text: "Component",
              standoff: 10,
            },
            tickangle: -45,
            tickfont: {
              size: 10,
            },
            automargin: true,
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
          },
          yaxis: { 
            title: yAxisTitle,
            type: this.yAxisScale || "linear",
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
          },
          margin: {
          l: 50,
          r: 0,
          b: 120
        },
          legend: { x: 1, y: 0.2, orientation: "v" },
        };

        const config = {
          responsive: true,
          displaylogo: false,
          displayModeBar: true,
          modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale","zoom", "toImage"],
           modeBarButtonsToAdd: [
            {
              name: "Expand",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${Expand}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.openModal,
            },
            {
              name: "Download CSV",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${downloadIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.handleDownloadCSV,
            },
            {
              name: "Download plot as a png",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${camIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.handleDownloadPNG,
            },
          ]
        };

        Plotly.newPlot(this.$refs[this.chartId], traces, layout, config);
      });
    },

    plotModalChart() {
      this.$nextTick(() => {
        const traces = this.chartData.map((series) => ({
          x: series.x,
          y: series.y,
          type: "scatter",
          mode: "lines+markers",
          name: series.name,
          line: {
            color: "#2199A8",
            width: 2
          },
          marker: {
            color: "#2199A8",
            size: 8,
            line: {
              color: "#2199A8",
              width: 1
            }
          },
          hovertemplate: `%{y:.3f}<extra></extra>`
        }));

        const yAxisTitle = this.toggleFraction ? "Mole%" : "Mass%";

        const layout = {
          // title: {
          //   text: this.chartTitle,
          //   font: { size: 12 },
          // },
          xaxis: {
            title: {
              text: "Component",
              standoff: 10,
            },
            tickangle: -45,
            tickfont: {
              size: 10,
            },
            automargin: true,
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
          },
          yaxis: { title: yAxisTitle,
            type: this.modalYAxisScale || "linear",
            gridcolor: this.isDarkMode ? '#74839A' : '#EFEFEF',
           },
          margin: {
          l: 50,
          r: 0,
          b: 120
        },
          legend: { x: 1, y: 0.2, orientation: "v" },
        };

        const config = {
          responsive: true,
          displaylogo: false,
           displayModeBar: true,
          modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale","zoom", "toImage"],
          modeBarButtonsToAdd: [
              {
              name: "Expand",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${Expand}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.openModal,
            },
            {
              name: "Download CSV",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${downloadIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.handleDownloadCSV,
            },
            {
              name: "Download plot as a png",
              icon: {
                svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${camIcon}" width="24" height="24"/>
                  </svg>
                `,
              },
              click: this.handleDownloadPNG,
            },
          ]
        };

        Plotly.Plots.resize(this.$refs[this.modalChartId])
        Plotly.newPlot(this.$refs[this.modalChartId], traces, layout, config);
      });
    },


    openModal() {
      this.modal = true;
      this.$nextTick(() => {
        this.plotModalChart();
      });
    },

    closeModal() {
      this.modal = false;
    },

    handleDownloadCSV() {
      this.downloadChartCSV();
    },

    downloadChartCSV() {
      // Create CSV header
      const csvHeader = ["Component,Value\n"];

      // Map through chartData and format it as CSV rows
      const csvRows = this.chartData.map((series) =>
        series.x.map((x, index) => `${x},${series.y[index]}`).join("\n")
      );

      // Combine header and rows
      const csvContent = csvHeader + csvRows.join("\n");

      // Create a Blob from the CSV content
      const blob = new Blob([csvContent], { type: "text/csv" });

      // Create a link element
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "chart-data.csv";

      // Programmatically click the link to trigger download
      a.click();

      // Cleanup
      URL.revokeObjectURL(url);
    },

    handleDownloadPNG() {
      this.downloadChartPNG();
    },

    downloadChartPNG() {
      const chartElement = this.$refs[this.chartId];
      if (chartElement) {
        // Create a temporary div for the download
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.left = '-9999px';
        tempDiv.style.top = '-9999px';
        document.body.appendChild(tempDiv);

        // Get the current plot data
        Plotly.restyle(chartElement, {}, [0]).then((currentData) => {
          Plotly.relayout(chartElement, {}).then((currentLayout) => {
            // Create layout with title
            const layoutWithTitle = { ...currentLayout };
            layoutWithTitle.title = {
              text: this.chartTitle,
              font: {
                size: 16,
                color: '#333'
              },
              x: 0.5,
              y: 0.95
            };

            // Create the temporary plot with title
            Plotly.newPlot(tempDiv, currentData, layoutWithTitle, {
              displayModeBar: false,
              responsive: true
            }).then(() => {
              // Download the PNG with title included
              Plotly.downloadImage(tempDiv, {
                format: 'png',
                filename: this.chartTitle || 'chart',
                height: 600,
                width: 800
              }).then(() => {
                // Clean up the temporary div
                document.body.removeChild(tempDiv);
              });
            });
          });
        });
      }
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>